"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIKeyEntity = void 0;
class APIKeyEntity {
    /**
     * @deprecated
     */
    _id;
    id;
    title;
    owner;
    apikey;
    sign;
    isArchived;
    expireAt;
    permissions;
    limitReqsPerDay;
    hooks;
    createdAt;
    updatedAt;
}
exports.APIKeyEntity = APIKeyEntity;
